import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { AppToast } from './shared/ui/app-toast/app-toast';
import { MenuCatalogRealtimeService } from './features/menu-catalog/services/menu-catalog-realtime.service';
import { OrderRealtimeDesktopNotificationsService } from './core/services/order-realtime-desktop-notifications.service';
import { OrdersBadgeService } from './shared/services/orders-badge.service';
import { PendingRequestsBadgeService } from './shared/services/pending-requests-badge.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppToast, DynamicDialogModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  /** Start singleton realtime consumers at bootstrap so events are not missed after connect. */
  private readonly _menuCatalogRealtime = inject(MenuCatalogRealtimeService);
  private readonly _orderDesktopNotifications = inject(OrderRealtimeDesktopNotificationsService);
  private readonly _ordersBadge = inject(OrdersBadgeService);
  private readonly _pendingRequestsBadge = inject(PendingRequestsBadgeService);
}
